import React from "react";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.27)",
  },
  content: {
    width: "fit-content",
    height: "fit-content",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "24px 20px 12px",
    transform: "translate(-50%, -50%)",
    background: "#FFFFFF",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.11)",
    borderRadius: "12px",
  },
};

const ModalTimeOut = ({ onClickLogout, onClickConnected, open }) => {
  const buttonStyles =
    "h-9 w-36 font-normal text-base bg-transparent text-primary-1";

  return (
    <Modal isOpen={open} style={customStyles} ariaHideApp={false}>
      <h3 className="font-semibold font-rubik text-left text-[17px] mb-3 ml-3 text-primary-4">
        Are you there?
      </h3>
      <p className="text-base font-rubik font-normal text-left ml-3 mb-4">
        We notice no activity in your screen.
        <br /> Do you want to keep connected?
      </p>
      <div className="flex justify-center gap-6">
        <button onClick={onClickLogout} className={`${buttonStyles}`}>
          Log out
        </button>
        <button onClick={onClickConnected} className={`${buttonStyles}`}>
          Keep connected
        </button>
      </div>
    </Modal>
  );
};

export default ModalTimeOut;
